module.exports = __webpack_public_path__ + "media/images/taxigo-platinum/points-1bebbb0f6577967319c58a8db9ad1e62.svg";